import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectableNavigationItem} from '../../../../model/selectable-navigation-item';
import {NavigationService} from '../../../../services/navigation/navigation.service';
import {EmitterConstants} from '../../../../shared/emitter-constants';
import {Emitter} from '../../../../shared/utils/emitter/emitter';
import {Trial} from '../../../../model/trial';
import {takeUntil} from 'rxjs/operators';
import {TvshopConstants} from '../../../../shared/tvshop-constants';
import {DtvCatalogUtils} from '../../../../utils/dtv-catalog/dtv-catalog.utils';
import {OmapiIdsUtils} from '../../../../shared/utils/omapi-ids/omapi-ids-utils';
import {UserTypeConstants} from '../../../../shared/user-type-constants';
import {OcapiSynchronousService} from '../../../../services/ocapi/ocapi.synchronous.service';
import {OcapiAsynchronousService} from '../../../../services/ocapi/ocapi.asynchronous.service';
import {TvShopStateService} from '../../../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-trial-comparison-button',
  templateUrl: './trial-comparison-button.component.html',
  styleUrls: ['./trial-comparison-button.component.less']
})
export class TrialComparisonButtonComponent extends SelectableNavigationItem implements OnInit {

  @Input() trial: Trial;

  @Output()
  emitTrialTimeOut = new EventEmitter<boolean>();
  @Output()
  emitActivationPending = new EventEmitter<boolean>();

  @Output()
  emitTrialActivation = new EventEmitter<Trial>();

  isPending = false;

  constructor(private navigationService: NavigationService,
              private changeDetection: ChangeDetectorRef,
              private ocapiSynchronousService: OcapiSynchronousService,
              private stateService: TvShopStateService,
              private ocapiAsynchronousService: OcapiAsynchronousService
  ) {
    super();
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, this.ownerComponent);
  }

  onBack(): void {
    this.onEmitSetPending(false);
    Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.ownerComponent);
  }

  onEnter(): void {
    if (this.trial && !this.isPending) {
      this.onEmitSetPending(true);
      this.onEmitSetTrialActivation();
      let activateTrialObservable;

      if (OmapiIdsUtils.currentUserType === UserTypeConstants.LEGACY_USER) {
        activateTrialObservable = this.ocapiAsynchronousService.activateTrial(this.trial);
      } else if (OmapiIdsUtils.currentUserType === UserTypeConstants.DWN_USER) {
        activateTrialObservable = this.ocapiSynchronousService.activateTrial(this.trial);
      }

      const activateTrial = activateTrialObservable
          .pipe(takeUntil(this.stopSubscription))
          .subscribe(response => {
            if (response.success) {
              this.onEmitSetPending(false);
              Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL).emit(this.trial);
              const packs = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
              DtvCatalogUtils.onTrialActivated(packs, this.trial);
              this.stateService.setTvShopEntertainmentPacks(packs);
            } else {
              this.onEmitSetPending(false);
              this.onBack();
              this.containsErrors('Trial could not be activated', response);
            }
          }, error1 => {
              this.onEmitSetPending(false);
              this.onBack();
              this.containsErrors('Trial could not be activated', error1);
          });
      this.activateTimeout(activateTrial);
      this.onEmitSetPending(this.isPending);
    }
  }


  activate(active: boolean): void {
    this.active = active;
    this.changeDetection.detectChanges();
  }

  public onEmitSetPending(isPending: boolean): void {
    this.isPending = isPending;
    this.emitActivationPending.emit(isPending);
  }


  public onEmitTrialTimeOut(isTimeout: boolean): void {
    this.emitTrialTimeOut.emit(isTimeout);
  }

  onEmitSetTrialActivation(): any {
    this.emitTrialActivation.emit(this.trial);
  }


  private activateTimeout(activateTrial) {
    setTimeout(() => {
      if (this.isPending) {
      activateTrial.unsubscribe();
      this.onEmitTrialTimeOut(true);
      this.onEmitSetPending(false);
      }
    }, TvshopConstants.MAXIMUM_ORDERING_COOL_DOWN_IN_MS);
  }
}
